import { useEffect, useState } from "react";
import { useNavigate, Link, useLocation, useSearchParams } from "react-router-dom";
import { Row, Col, Grid } from "antd";
import { MySegmented, MyText } from "../../components";
import { ButtonContainer, ScrollableCol } from './style';
import { LeftOutlined } from "@ant-design/icons";
import {useTranslation} from "react-i18next";
import { useLang } from "../../utils/context/lang";
import { useEmbeddedNavigate, useEmbeddedLink } from "../../utils/context/embed";
import { Helmet } from "react-helmet";
import { useDispatch, useSelector } from "react-redux";
import { fetchMaterialsDetailAction, fetchMaterialsTreeAction, RootState, selectStore } from "../../utils";

const isMobile = window.innerWidth < 768;

export const MaterialsPage = () => {
  const {t} = useTranslation("common")
  const { lang } = useLang();
  const [selectedSegment, setSelectedSegment] = useState<string | undefined>();
  const navigate = useNavigate();
  const embeddedNavigate = useEmbeddedNavigate();
  const embeddedLink = useEmbeddedLink();
  const dispatch = useDispatch();
  const materialsTree = useSelector((state: any) => state.materials.materialsTree);
  const materialsDetail = useSelector((state: any) => state.materials.materialsDetail);

  const specialistTypes = materialsDetail.data?.types || [];
  const materials = materialsDetail.data?.materials || [];
  const location = useLocation();
  const [searchParams] = useSearchParams();
  const [type, setType] = useState();
  const { useBreakpoint } = Grid;
  const screens = useBreakpoint();
  const parentId = Number(searchParams.get('id'));
  // const [materials, setMaterials] = useState<any[]>([]);
  // const [specialistTypes, setSpecialistTypes] = useState<any[]>([]);
  const parentType = searchParams.get('type');
  const isEarly = location.pathname === "/materials/early";

  useEffect(() => {
    dispatch(fetchMaterialsTreeAction(undefined));
  }, [isEarly, lang]);

useEffect(() => {
  if (!materialsTree.success || !materialsTree.data?.tree) return;

  const filteredData = materialsTree.data.tree.filter((item: any) => item.type === "0");

  if (filteredData.length > 0) {
    const targetId = isEarly ? filteredData[0]?.id : filteredData[1]?.id;

    if (targetId !== undefined && targetId !== parentId) {
      const newPath = `${location.pathname}?id=${targetId}?type=${parentType}`;
      embeddedNavigate(newPath, { replace: true });
      dispatch(fetchMaterialsDetailAction({ id: targetId, segmentedParams: parentType }));
    } else {
      dispatch(fetchMaterialsDetailAction({ id: parentId, segmentedParams: parentType }));
    }
  }
}, [materialsTree.success, materialsTree.data]);

useEffect(() => {
  if (!materialsDetail.success || !materialsDetail.data) return;

  const { types } = materialsDetail.data;

  if (types?.length > 0) {
    const defaultSegment = parentType
      ? types.find((t: any) => t.label === parentType)?.value ?? types[0].value
      : types[0].value;

    setSelectedSegment(String(defaultSegment));
  }
}, [materialsDetail.success, materialsDetail.data]);

const selectedSegmentLabel = specialistTypes.find(
  (t: any) => String(t.value) === String(selectedSegment)
)?.label;

  const handleClick = () => {
    embeddedNavigate('/');
  };


 const handleChangeSegmented = (value: any) => {
  setSelectedSegment(value);
  
  const selectedType = specialistTypes.find((t: any) => String(t.value) === String(value));
  if (selectedType) {
    const newPath = `${location.pathname}?id=${parentId}&type=${selectedType.label}`;
    embeddedNavigate(newPath);
    dispatch(fetchMaterialsDetailAction({ id: parentId, segmentedParams: selectedType.label }));
  }
};
    const getAgeRange = () => {
      if (specialistTypes.length === 0) return ['0', '0'];

      const ageRanges = specialistTypes.map((type: any) => {
        const [min, max] = type.label.split('-').map(Number);
        return { min, max };
      });

      const minAge = Math.min(...ageRanges.map((r: any) => r.min));
      const maxAge = Math.max(...ageRanges.map((r: any) => r.max));
      return [minAge, maxAge];
    };

  const [minAge, maxAge] = getAgeRange();


  return (
    <>
<Helmet>
  <title>
      {isEarly
        ? "Развитие детей раннего возраста – задания, игры, мультфильмы, советы родителям"
        : "Обучение и развитие дошкольников – задания, игры, мультфильмы, советы родителям, подготовка к школе"}
    </title>
    <meta
      name="description"
      content={
        isEarly
          ? "Методики для гармоничного развития малышей до 2 лет"
          : "Игры, упражнения и советы для родителей детей 3–6 лет. Подготовка к школе и развитие мышления, речи и внимания."
      }
    />
    <meta
      name="keywords"
      content={
        isEarly
          ? "развивающие игры, упражнения для детей, логика, математика, внимание"
          : "развивающие игры, упражнения для детей, логика, математика, внимание, подготовка к школе"
      }
    />
  </Helmet>

    <Row justify='center'>
      <Col span={20}>
        <Row gutter={[24, 24]}>
          <Col span={24}>
            {/* <div style={{ display: 'flex', gap: isMobile ? '14px' : '24px', alignItems: 'center' }}>
              <ButtonContainer onClick={handleClick}>
                <LeftOutlined style={{ color: 'rgba(10, 3, 60, 0.7)' }} />
              </ButtonContainer>
              <MyText color='#0A033C' size={isMobile ? 22 : 32} weight={800} style={{ fontFamily: 'Nunito', display: 'block' }}>
              {isEarly ? `${t("youngAge")}` : `${t("preschoolAge")}`}
              </MyText>
            </div> */}
          <Row align="middle" style={{ height: '60px'}}>

            {screens.xs ? (
                <>
                  <Col span={3}>
                    <ButtonContainer onClick={handleClick}>
                      <LeftOutlined style={{ color: 'rgba(10, 3, 60, 0.7)' }} />
                    </ButtonContainer>
                  </Col>
                  <Col span={21}>
                    <MyText
                      color="rgba(19, 15, 38, 1)"
                      size={26}
                      weight={800}
                      style={{ fontFamily: 'Nunito', display: 'block', marginLeft: 12 }}
                    >
                      {isEarly ? `${t("youngAge")}` : `${t("preschoolAge")}`}
                    </MyText>
                  </Col>
                </>
              ) : (
                <>
                  <ButtonContainer onClick={handleClick}>
                    <LeftOutlined style={{ color: 'rgba(10, 3, 60, 0.7)' }} />
                  </ButtonContainer>
                  <MyText
                    color="rgba(19, 15, 38, 1)"
                    size={32}
                    weight={800}
                    style={{ fontFamily: 'Nunito', display: 'block', marginLeft: 12 }}
                  >
                    {isEarly ? `${t("youngAge")}` : `${t("preschoolAge")}`}
                  </MyText>
                </>
              )}
          </Row>

          </Col>
          <Row gutter={[24, 24]}>
          <ScrollableCol span={24}>
            {specialistTypes.length > 0 && (
              <MySegmented
                type='primary'
                options={specialistTypes.map(item => ({
                  label: item.label,
                  value: String(item.value)
                }))}
                onChange={handleChangeSegmented}
                value={selectedSegment}
              />
            )}
          </ScrollableCol>
          </Row>
          <Col span={24} style={{padding: '0px'}}>
          <Row gutter={[24, 24]}>
              {materials.map((material, index) => (
                <Col span={isMobile ? 24 : 8} key={index}>
                  <Link 
                      to={embeddedLink(`/materials/detail?id=${material.id}&age=${selectedSegmentLabel}&parentId=${parentId}`)}
                      state={{ parentPath: location.pathname, parentId: parentId }}
                      style={{ textDecoration: 'none' }}
                    >
                    <div style={{ 
                      borderRadius: '12px', 
                      height: '93px', 
                      display: 'flex', 
                      background: '#fff', 
                      alignItems: 'center' 
                    }}>
                      <div style={{ width: '83px', height: '63px', margin: '15px', overflow: 'hidden' }}>
                        <img 
                          src={material.icon || 'path_to_default_image'} 
                          alt="Material"
                          style={{ width: '63px', height: '63px', objectFit: 'cover' }}
                        />
                      </div>
                      <div style={{ 
                        display: 'flex', 
                        width: '100%', 
                        flexDirection: 'column', 
                        justifyContent: 'center' 
                      }}>
                        <MyText color='#0A033C' size={20} lineHeight="24px" weight={800} style={{ fontFamily: 'Nunito' }}>
                          {material.name}
                        </MyText>
                      </div>
                    </div>
                  </Link>
                </Col>
              ))}
            </Row>
          </Col>

          {/* </Col> */}
        </Row>
      </Col>
    </Row>
    </>
  );
};
